import { List } from 'immutable'
import setFilters from 'store/reducer-utils/setFilters'
import { updateObject } from 'utils/updateObject'
import {
  ACCESS_DROP_LIST,
  ACCESS_REMOVE_FROM_LIST,
  ACCESS_SET_FILTER,
  ACCESS_SET_LOADING,
  ACCESS_SET_PROCESSING_IDS,
  ACCESSES_SET_LIST,
} from 'modules/Services/types'

const initialState = {
  deleteQueue: {
    processingIds: [],
  },
  loading: true,
  data: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
  filters: null,
}

const setAccesses = (state, { payload }) =>
  updateObject(state, {
    ...payload,
    data: List(state.data).concat(List(payload.data)).toJS(),
    loading: false,
  })

const setLoading = (state, { payload }) => updateObject(state, payload)

const dropList = (state) =>
  updateObject(state, {
    loading: true,
    data: [],
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
  })

const removeFromList = (state, { payload }) =>
  updateObject(state, {
    data: state.data.filter((item) => !payload.includes(item.id)),
  })

const setAccessFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setProcessingIds = (state, { payload }) =>
  updateObject(state, {
    deleteQueue: {
      processingIds: payload,
    },
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACCESS_SET_LOADING:
      return setLoading(state, action)
    case ACCESSES_SET_LIST:
      return setAccesses(state, action)
    case ACCESS_SET_FILTER:
      return setAccessFilters(state, action)
    case ACCESS_SET_PROCESSING_IDS:
      return setProcessingIds(state, action)
    case ACCESS_REMOVE_FROM_LIST:
      return removeFromList(state, action)
    case ACCESS_DROP_LIST:
      return dropList(state, action)
    default:
      return state
  }
}

export default reducer
